import styled from "styled-components";

export const Container = styled.a`
    width: 100%;
    height: 280px;
    background-color: aquamarine;
    
    & > img {
        width: 100%;
        height: 100%;
    }
`;